module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.showGallery) ? _c('gallery', {
    attrs: {
      "images": _vm.product.images
    },
    on: {
      "closeGallery": _vm.closeGallery
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "pagination_area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "pagination_box"
  }, [_c('ul', [_vm._l((_vm.categories), function(c, i) {
    return _c('li', [_c('router-link', {
      attrs: {
        "tag": "a",
        "to": '/list?filter=' + _vm.createNavigationUrl(c.id)
      }
    }, [_vm._v(_vm._s(c.name) + "\n                                     "), _c('i', {
      staticClass: "fa fa-angle-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)
  }), _vm._v(" "), _vm._m(0)], 2)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "soproni_big_area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [(_vm.product.parentCategory) ? _c('filter-view', {
    attrs: {
      "propertyGroups": [],
      "sc": _vm.product.parentCategory
    },
    on: {
      "filterChanged": _vm.categorySelected
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "row soproni_big_area_white",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "soproni_big_can"
  }, [_c('div', {
    staticClass: "soproni_big_can_img text-center"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.product.imageUrl,
      "alt": ""
    },
    on: {
      "click": _vm.openGallery
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "soproni_big_conts"
  }, [_c('div', {
    staticClass: "soproni_big_conts_box"
  }, [_c('div', {
    staticClass: "soproni_klasszikus"
  }, [_c('div', {
    staticClass: "soproni_klasszikus_title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.product.name))])]), _vm._v(" "), _c('div', {
    staticClass: "soproni_klasszikus_price_box"
  }, [_c('div', {
    staticClass: "soproni_klasszikus_price"
  }, [_c('h4', [_vm._v("Bruttó " + _vm._s(_vm.product.price && _vm.product.price.toLocaleString('hu')) + " Ft "), _c('span', [_vm._v(_vm._s(_vm.product.originalPrice == 0 ? '' : (_vm.product.originalPrice && _vm.product.originalPrice.toLocaleString('hu')) + ' Ft'))])]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Nettó " + _vm._s((_vm.product.price / 1.27).toFixed(0).toLocaleString('hu')) + " Ft "), _c('span', [_vm._v(_vm._s(_vm.product.originalPrice == 0 ? '' : (_vm.product.originalPrice / 1.27).toFixed(0).toLocaleString('hu') + ' Ft'))])])])]), _vm._v(" "), (_vm.product.additionalFields) ? _c('div', {
    staticClass: "soproni_klasszikus_ingri"
  }, [_vm._l((_vm.product.propertyGroups), function(pg) {
    return _c('section', [(pg.propertyGroup.type == 'VALUE') ? _c('p', [_vm._v("\n                                                    " + _vm._s(pg.propertyGroup.name) + ": " + _vm._s(pg.value) + "\n                                                ")]) : _vm._e(), _vm._v(" "), _vm._l((pg.properties), function(p) {
      return _c('p', [_vm._v("\n                                                    " + _vm._s(pg.propertyGroup.name) + ": " + _vm._s(p.name) + "\n                                                ")])
    })], 2)
  }), _vm._v(" "), _c('p', [_vm._v("\n                                                " + _vm._s(_vm.product.additionalFields.type == 'KG' ? 'Tömeg' : 'Térfogat') + ": " + _vm._s(_vm.product.additionalFields.type == 'KG' ? _vm.product.additionalFields.netWeight / 1000 : _vm.product.additionalFields.volume) + " " + _vm._s(_vm.product.additionalFields.type == 'KG' ? 'kg' : 'L') + "\n                                            ")]), _vm._v(" "), (_vm.product.additionalFields.alcohol && _vm.product.additionalFields.alcohol != 0) ? _c('p', [_vm._v("\n                                                Alkoholtartalom: " + _vm._s(_vm.product.additionalFields.alcohol) + "%\n                                            ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n                                                Bruttó egységár: " + _vm._s((_vm.product.price / (_vm.product.additionalFields.type == 'KG' ? _vm.product.additionalFields.netWeight / 1000 : _vm.product.additionalFields.volume)).toFixed(0).toLocaleString('hu')) + " Ft/" + _vm._s(_vm.product.additionalFields.type == 'KG' ? 'kg' : 'L') + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                                                " + _vm._s(_vm.product.description) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Rendelési adatok")]), _vm._v(" "), _c('p', [_vm._v("\n                                                Bruttó tömeg: " + _vm._s((_vm.product.additionalFields.netWeight + _vm.product.additionalFields.additionalWeight) / 1000) + " kg\n                                            ")]), _vm._v(" "), (_vm.product.additionalFields.additionalPrice > 0) ? _c('p', [_vm._v("\n                                                Üveg betétdíj: " + _vm._s(_vm.product.additionalFields.additionalPrice.toLocaleString('hu')) + " Ft\n                                            ")]) : _vm._e(), _vm._v(" "), (_vm.product.additionalFields.minOrderQuantity > 0) ? _c('p', [_vm._v("\n                                                Minimális rendelési mennyiség: " + _vm._s(_vm.product.additionalFields.minOrderQuantity) + " db\n                                            ")]) : _vm._e(), _vm._v(" "), (_vm.product.additionalFields.packageSize > 0) ? _c('p', [_vm._v("\n                                                Egy csomag: " + _vm._s(_vm.product.additionalFields.packageSize) + " db termék\n                                            ")]) : _vm._e(), _vm._v(" "), (_vm.product.additionalFields.additionalPackageWeight > 0) ? _c('p', [_vm._v("\n                                                Rekesz súly: " + _vm._s(_vm.product.additionalFields.additionalPackageWeight / 1000) + " kg\n                                            ")]) : _vm._e(), _vm._v(" "), (_vm.product.additionalFields.additionalPackagePrice > 0) ? _c('p', [_vm._v("\n                                                Rekesz betétdíj: " + _vm._s(_vm.product.additionalFields.additionalPackagePrice.toLocaleString('hu')) + " Ft\n                                            ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.product.availableQuantity) ? _c('p', [_vm._v("A termék jelenleg készleten van.")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "big_quantity_boxs"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product.availableQuantity) ? [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', [_c('form', {
    attrs: {
      "id": "form",
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group spinner"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quantity),
      expression: "quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quantity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn-vertical"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.increment
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.decrement
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "big_quantity_btn"
  }, [_c('a', {
    on: {
      "click": _vm.addToBasket
    }
  }, [_vm._v("Kosárba"), _c('i', {
    staticClass: "fa fa-shopping-basket",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])] : _c('div', [_c('div', {}, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "line-height": "1"
    }
  }, [_vm._v("\n                                                            Vásárlási szándékát az alábbi gomb megnyomásával jelezheti felénk, miután beírta a vásárolni kívánt mennyiséget. A termék ára csak tájékoztató jellegű, válasz üzenetben értesítjük a termék aktuális áráról és szállítás várható időpontjáról.\n                                                            "), (!_vm.isLoggedIn) ? _c('span', [_c('br'), _vm._v("Kérem adja meg az email címét is.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 inputs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wishObj.quantity),
      expression: "wishObj.quantity"
    }],
    attrs: {
      "type": "number",
      "placeholder": "Mennyiség"
    },
    domProps: {
      "value": (_vm.wishObj.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.wishObj, "quantity", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.isLoggedIn) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wishObj.email),
      expression: "wishObj.email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email cím"
    },
    domProps: {
      "value": (_vm.wishObj.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.wishObj, "email", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "big_quantity_btn",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    on: {
      "click": _vm.addToWishlist
    }
  }, [_vm._v("Küldés"), _c('i', {
    staticClass: "fa fa-send",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    on: {
      "click": _vm.addRemoveWatched
    }
  }, [_c('img', {
    staticClass: "star",
    attrs: {
      "src": _vm.isWatched ? 'images/star_minus.png' : 'images/star_plus.png',
      "alt": ""
    }
  })])])], 2)])])])])])])]), _vm._v(" "), (_vm.product.parentCategory) ? _c('promoted', {
    attrs: {
      "categoryId": _vm.product.parentCategory.id
    }
  }) : _vm._e()], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "onclick": "history.back()"
    }
  }, [_vm._v("\n                                    Vissza az előző oldalra\n                                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62da9596","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/product/ProductDetailed.vue
// module id = 285
// module chunks = 2